import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import flespiDeviceService from '../../../../services/FlespiDeviceService';
import toast from 'react-hot-toast';
import ReactSelect from 'react-select';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  makeStyles,
  Divider,
  AccordionActions,
  Button,
  TextField,
  InputAdornment,
  Switch
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsIcon from '@material-ui/icons/Settings';
import SendIcon from '@material-ui/icons/Send';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: '#757575',
    fontWeight: '700'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary
  },
  accordionSummaryDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  settingsDiv: {
    marginRight: '12px'
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column'
  },
  accordionDetailsItem: {
    marginBottom: '1rem'
  }
}));

const prioOptions = [
  { value: 'disable', label: 'Disable', id: 0 },
  { value: 'low', label: 'Low', id: 1 },
  { value: 'high', label: 'High', id: 2 },
  { value: 'panic', label: 'Panic', id: 3 }
];

const AccelerometerTab = ({ selectedTabSettings }) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: {
      prio: selectedTabSettings[0]?.current?.prio,
      record: selectedTabSettings[0]?.current?.record,
      move_time: selectedTabSettings[0]?.current?.move_time,
      stop_time: selectedTabSettings[0]?.current?.stop_time
    }
  });

  const handleAccelerometer = (data) => {
    // eslint-disable-next-line no-console, no-undef
    console.log('data', data);
    setLoading(true);

    const accelerometerPayload = {
      deviceId: selectedTabSettings[0]?.device_id,
      settSelector: 'idling_obd',
      properties: {
        prio: data.prio,
        record: data.record,
        move_time: data.move_time,
        stop_time: data.stop_time
      }
    };

    // eslint-disable-next-line no-console, no-undef
    console.log('accelerometerPayload', accelerometerPayload);

    flespiDeviceService
      .updateFlespiDeviceSetting(accelerometerPayload)
      .then((data) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('data is:', data);
        toast.success('Successfully updated accelerometer setting');
      })
      .catch((error) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('error', error?.move_time?.data?.message);
        toast.error(error?.move_time?.data?.message || 'Unable to update accelerometer settings');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // eslint-disable-next-line no-console, no-undef
  console.log('errors are,', errors);

  return (
    <div style={{ marginBottom: '1rem' }}>
      <form onSubmit={handleSubmit(handleAccelerometer)}>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className={classes.accordionSummary}
          >
            <div className={classes.accordionSummaryDiv}>
              <div className={classes.settingsDiv}>
                <SettingsIcon />
              </div>

              <div>
                <Typography className={classes.heading}>Excessive Idling Detection</Typography>
                <Typography className={classes.secondaryHeading}>
                  Excessive idling detection scenario settings
                </Typography>
              </div>
            </div>
          </AccordionSummary>

          <Divider />

          <AccordionDetails className={classes.accordionDetails}>
            <Typography style={{ color: '#9e9e9e', marginBottom: '10px' }}>Excessive Idling Detection</Typography>

            {/* prio */}
            <div style={{ marginBottom: '1rem' }}>
              <Controller
                name="prio"
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    options={prioOptions}
                    isSearchable
                    value={prioOptions?.find((option) => option.id === field.value)}
                    onChange={(selected) => field.onChange(selected ? selected.id : null)}
                    classNamePrefix="select"
                    name="prio"
                    // eslint-disable-next-line no-undef
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 2 }) }}
                  />
                )}
              />
              {errors.prio && (
                <Typography color="error" style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>
                  {errors.prio.message}
                </Typography>
              )}
            </div>

            {/* record */}
            <div className={classes.accordionDetailsItem}>
              <Controller
                control={control}
                name="record"
                render={({ field }) => (
                  <Switch
                    name="record"
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    color="primary"
                  />
                )}
              />
              <label> Eventual Record</label>
            </div>

            <div className={classes.accordionDetailsItem}>
              <Controller
                name="stop_time"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Stop Timeout"
                    size="small"
                    type="number"
                    fullWidth
                    variant="outlined"
                    {...field}
                    error={!!errors.stop_time}
                    helperText={errors.stop_time?.message}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Seconds</InputAdornment>
                    }}
                  />
                )}
              />
            </div>

            <div className={classes.accordionDetailsItem}>
              <Controller
                name="move_time"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Move Timeout"
                    size="small"
                    type="number"
                    fullWidth
                    variant="outlined"
                    {...field}
                    error={!!errors.move_time}
                    helperText={errors.move_time?.message}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Seconds</InputAdornment>
                    }}
                  />
                )}
              />
            </div>
          </AccordionDetails>

          <AccordionActions style={{ cursor: 'pointer' }}>
            <Button
              size="small"
              color="primary"
              title="Changes will apply to the device"
              type="submit"
              disabled={loading}
            >
              <SendIcon />
            </Button>
          </AccordionActions>
        </Accordion>
      </form>
    </div>
  );
};

export default AccelerometerTab;

AccelerometerTab.propTypes = {
  selectedTabSettings: PropTypes.array
};
